/**
 * @method setAlertModal
 */
export function ModalController () {
    this.alertModal = null;
    this.loadingModal = null;
    this.confirmModal = null;

    this.setAlertModal = function(alertModalController) {
        this.alertModal = alertModalController;
    };

    this.setLoadingModal = function(loadingModalController) {
        this.loadingModal = loadingModalController;
    };

    this.setConfirmModal = function(confirmModalController) {
        this.confirmModal = confirmModalController;
    };

    this.setRegisterSuccessModal = function(registerSuccessModalController) {
        this.registerSuccessModal = registerSuccessModalController;
    };

    this.setTermsModal = function(termsModalController) {
        this.termsModal = termsModalController;
    };

}
